<template>
    <div class="leads-filter-bar" v-if="readyToRender">
        <div class="filter--overlay"></div>
        <div class="row">
            <div class="col-md-2 form-group">
                <label>Recherche</label>
                <custom-text :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="updateData($event.new_value, 'search_entry')"></custom-text>
            </div>
            <div class="col-md-2 form-group">
                <label>Etat</label>
                <custom-select :field="fields[1]" :value="fields[1].value" :field_idx="1" @field-updated="updateData($event.new_value, 'search_state')"
                    :opt="false"></custom-select>
            </div>
            <div class="col-md-2 form-group">
                <label>Origine</label>
                <custom-select :field="fields[2]" :value="fields[2].value" :field_idx="2" @field-updated="updateData($event.new_value, 'search_origin')"
                    :opt="false">
                </custom-select>
            </div>
            <div class="col-md-2 form-group">
                <label>Créés depuis le</label>
                <custom-datepicker :field="fields[3]" :value="fields[3].value" :field_idx="3" @field-updated="updateData($event.new_value, 'created_since')">
                </custom-datepicker>
            </div>
            <div class="col-md-2 form-group">
                <label>Créés jusqu'au</label>
                <custom-datepicker :field="fields[4]" :value="fields[4].value" :field_idx="4" @field-updated="updateData($event.new_value, 'created_until')">
                </custom-datepicker>
            </div>
            <div class="col-md-2">
                <button class="btn btn-success button-margin-top pull-right" @click="$emit('add-new-lead')" v-if="!addition_state">
                    <i class="fa fa-plus"></i>
                    Ajouter un lead
                </button>
                <button class="btn button-margin-top pull-right" style="background-color:white;" @click="$emit('cancel-add-new-lead')"
                    v-if="addition_state">
                    Annuler
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 form-group" v-if="check_access">
                <label>Agence</label>
                <custom-select :field="fields[5]" :value="fields[5].value" :field_idx="5" @field-updated="updateData($event, 'agencies')">
                </custom-select>
            </div>
            <div class="col-md-5 form-group">
                <label>Type d'offre sélectionné</label>
                <custom-select :field="fields[6]" :value="fields[6].value" :field_idx="6" @field-updated="updateData($event, 'methods')">
                </custom-select>
            </div>

            <div class="col-md-2 form-group" :class="export_css_class()">
                <button class="btn btn-default pull-right button-margin-bottom" v-if="canExport" @click="exportToCSV">
                    <i class="fa fa-share-square-o"></i>
                    Exporter
                </button>

                <button class="btn btn-default pull-right button-margin-bottom" @click="fetch">
                    <i class="fa fa-refresh"></i>
                    Rafraichir
                </button>
            </div>

        </div>
    </div>
</template>
<script>
    import Select2 from "components/Form/Select2"
    import CustomText from "components/Forms/Elements/Text"
    import CustomDatepicker from "components/Forms/Elements/Datepicker"
    import CustomSelect from "components/Forms/Elements/Select"
    import {
        mapGetters,
        mapActions,
        mapState
    } from "vuex"
    import distrib_methods from "utils/crm_distrib_methods"
    import vSelect from 'vue-select'

    export default {
        name: "CRM_FilterBar",

        components: {
            CustomText,
            CustomSelect,
            CustomDatepicker,
            Select2,
            vSelect
        },

        props: ["addition_state"],

        data() {
            return {
                fields: [],
                debounced_search: null,
                search_entry: "",
                search_origin: "none",
                search_state: "none",
                created_since: null,
                created_until: null,
                search_agency: [],
                options_state: [
                    {
                        id: "none",
                        text: "Tous"
                    },
                    {
                        id: "open",
                        text: "Ouvert"
                    },
                    {
                        id: "completed",
                        text: "Contrat complété"
                    },
                    {
                        id: "in_progress",
                        text: "En cours"
                    },
                    {
                        id: "converted",
                        text: "Converti"
                    },
                    {
                        id: "duplicate",
                        text: "Doublon"
                    },
                    {
                        id: "closed",
                        text: "Abandonné"
                    }
                ],
                options_available: [{
                        id: "none",
                        text: "Toutes"
                    },
                    {
                        id: "frontweb",
                        text: "Frontweb"
                    },
                    {
                        id: "sofradom_contact",
                        text: "Formulaire de contact du site sofradom.fr"
                    },
                    {
                        id: "sofradom_call_me_back",
                        text: "Formulaire de rappel du site sofradom.fr"
                    },
                    {
                        id: "agency_space",
                        text: "Formulaire de création manuelle de lead de l'espace agences"
                    },
                    {
                        id: "purchase_tunnel",
                        text: "Création automatique depuis le tunnel d'achat"
                    },
                ],
                selected_distribution_method: [],
                options_distribution_method: distrib_methods,
                already_fetched: false,
                selected_search_agencies: [],
                search_user_groups: [],
                not_assigned: 0,
                readyToInitSelect: false
            }
        },

        created() {
            this.fetchCrmRelatedUserGroups()
        },

        mounted() {
            this.debounced_search = _.debounce(this.fetch, 1000)

            if (!this.check_access) {
                this.initSearchAgency()
            }
            // console.warn('FB mounted : ', this.search_agency)

            this.selected_distribution_method = this.isAgency ? [-1, 1, 2] : []

            this.init_fields()
        },

        computed: {
            ...mapGetters(["isAgency"]),
            ...mapGetters("crm", ["is_fetching", "page_of_leads", "leads_to_export", 'userGroups']),
            ...mapGetters("customers", ["selectAgenciesList"]),
            ...mapState(["user", "agencies"]),

            full_agencies() {
                let optionsList = []
                // Formate et ajoute la première option 'not assigned' à la liste d'options
                optionsList.push({
                    id: 'not_assigned.' + 0,
                    name: 'Pas d\'agence'
                })
                // Formate et ajoute les user_groups à la liste d'options
                _.map(this.userGroups, (group) => {
                    optionsList.push({
                        id: 'user_group.' + group.id,
                        name: group.display_name
                    })
                })
                // Récupère seulement les agences non virtuelles
                const realAgencies = _.filter(this.agencies, a => !a.virtual)
                // Formate et ajoute les agences à la liste d'options
                _.map(realAgencies, (agency) => {
                    optionsList.push({
                        id: 'agency.' + agency.id,
                        name: agency.name
                    })
                })

                return optionsList
            },

            canExport() {
                return _.find(this.user.me.groups, group => group.name == "export") !== undefined
            },

            check_access() {
                var res = false
                if (this.user && this.user.me)
                    _.each(this.user.me.roles, (role) => {
                        if (role.name == 'green-number' || role.name == 'manager' || role.name == 'administrator' ||
                            role.name == 'super-administrator')
                            res = true
                    })
                return res
            },

            readyToRender() {
                return this.fields.length > 0 && this.userGroups.length > 0
            },

        },

        methods: {
            ...mapActions("crm", ["fetch_all_leads", "set_fetching_state", "set_search_params", "get_user_info", "fetch_all_leads_for_export", 'fetchCrmRelatedUserGroups']),

            export_css_class() {
                return this.check_access ? "col-md-2" : "col-md-12"
            },

            fetch() {
                this.set_fetching_state(true)

                let p = {
                    search: this.search_entry,
                    status: this.search_state == 'none' ? null : this.search_state,
                    origin: (this.search_origin === "none" ? null : this.search_origin),
                    creation_start_date: (this.created_since != null ? moment(this.created_since, "DD/MM/YYYY").format(
                        "YYYY-MM-DD") : null),
                    creation_end_date: (this.created_until != null ? moment(this.created_until, "DD/MM/YYYY").format(
                        "YYYY-MM-DD") : null),
                    agencies: this.selected_search_agencies,
                    distribution_methods: this.selected_distribution_method,
                    user_groups: this.search_user_groups,
                    not_assigned : this.not_assigned
                }


                this.set_search_params(p)

                this.fetch_all_leads(p).then(() => this.set_fetching_state(false))
            },

            download(filename, text) {
                var element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
                element.setAttribute('download', filename);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            },

            exportToCSV() {
                const json2csv = require('json2csv')
                if (!this.check_access)
                    this.search_agency = _.map(this.user.agencies, agency => {
                        return String(agency.id)
                    })
                this.set_fetching_state(true)
                this.fetch_all_leads_for_export({
                    search: this.search_entry,
                    status: this.search_state == 'none' ? null : this.search_state,
                    origin: this.search_origin === "none" ? null : this.search_origin,
                    creation_start_date: this.created_since != null ? moment(this.created_since, "DD/MM/YYYY").format(
                        "YYYY-MM-DD") : null,
                    creation_end_date: this.created_until != null ? moment(this.created_until, "DD/MM/YYYY").format(
                        "YYYY-MM-DD") : null,
                    agencies: this.selected_search_agencies,
                    distribution_methods: this.selected_distribution_method,
                    user_groups: this.search_user_groups,
                    not_assigned : this.not_assigned
                }).then(() => {
                    this.set_fetching_state(false)
                    var fields = [
                        "id",
                        "decoded_status", "decoded_origin", "contact_company_name", "contact_civility", "contact_first_name", "contact_last_name",
                        "contact_email", "contact_phone", "contact_supplement", "closing_reason",
                        "origin_message", "decoded_origin_supplement",
                        "customer.name", "customer.activity",
                        "offers.name", "offers.distributed_product.agency.display_name",
                        "creating_user.email",
                        "created_at",
                    ]
                    var csv = json2csv({
                        data: this.leads_to_export,
                        fields: fields,
                        unwindPath: ['offers']
                    })
                    var filename = "exported-leads.csv"
                    this.download(filename, csv);
                })
            },

            updateData(v, vname) {
                if (vname == "search_entry") {
                    this.search_entry = v
                } else if (vname == "search_state") {
                    this.search_state = v.value
                } else if (vname == "search_origin") {
                    this.search_origin = v.value
                } else if (vname == "created_since") {
                    this.created_since = v == 'Invalid date' ? null : v
                } else if (vname == "created_until") {
                    this.created_until = v == 'Invalid date' ? null : v
                } else if (vname == "agencies") {
                    // console.log(v)
                    this.search_agency = _.map(v.new_value, vv => vv.value)
                } else {
                    this.selected_distribution_method = _.map(v.new_value, vv => vv.value)
                }
            },

            initSearchAgency() {
              const localUserAgencies = _.map(this.user.agencies, agency => 'agency.' + agency.id)
              const filteredUserGroups = _.filter(this.user.me.groups, group => 1 == group.crm_related)
              const localUserGroups = _.map(filteredUserGroups, group => 'user_group.' + group.id)

              this.search_agency = [...localUserAgencies, ...localUserGroups]
            },

            init_fields() {
                let v = [{
                        values: [],
                        multiple: false,
                        placeholder: "Par raison sociale, nom, email ou n° téléphone",
                        disabled: this.is_fetching,
                        idx: 0,
                        required: false,
                        value: this.search_entry,
                        label: "Recherche",
                        type: "text"
                    },
                    {
                        values: this.options_state,
                        multiple: false,
                        placeholder: "",
                        disabled: this.is_fetching,
                        idx: 1,
                        required: false,
                        value: this.search_state,
                        label: "Etat",
                        type: "select"
                    },
                    {
                        values: this.options_available,
                        multiple: false,
                        placeholder: "",
                        disabled: this.is_fetching,
                        idx: 2,
                        required: false,
                        value: this.search_origin,
                        label: "Origine",
                        type: "select"
                    },
                    {
                        values: [],
                        multiple: false,
                        placeholder: "Sélectionner une date",
                        disabled: this.is_fetching,
                        idx: 3,
                        required: false,
                        value: null,
                        label: "Crée depuis le",
                        type: "date"
                    },
                    {
                        values: [],
                        multiple: false,
                        placeholder: "Sélectionner une date",
                        disabled: this.is_fetching,
                        idx: 4,
                        required: false,
                        value: null,
                        label: "Crée jusqu'au",
                        type: "date"
                    },
                    {
                        values: this.full_agencies,
                        multiple: true,
                        placeholder: "",
                        disabled: this.is_fetching,
                        idx: 5,
                        required: false,
                        value: this.isAgency ? this.search_agency : null,
                        label: "Agence",
                        type: "select"
                    },
                    {
                        values: this.options_distribution_method,
                        multiple: true,
                        placeholder: "",
                        disabled: this.is_fetching,
                        idx: 6,
                        required: false,
                        value: this.selected_distribution_method,
                        label: "Type d'offre",
                        type: "select"
                    },
                ]
                this.fields = v
            }
        },

        watch: {
            search_entry: function () {
                this.debounced_search()
            },

            search_origin: function () {
                this.fetch()
            },

            created_since: function () {
                this.fetch()
            },

            created_until: function () {
                this.fetch()
            },

            search_state: function () {
                this.fetch()
            },

            search_agency: function (newv, oldv) {
                this.selected_search_agencies = []
                this.search_user_groups = []
                this.not_assigned = 0

                _.each(newv, (vv) => {
                    const newvArray = vv.split('.')

                    if (newvArray[0] === 'agency') {
                        this.selected_search_agencies.push(newvArray[1])
                    } else if (newvArray[0] === 'user_group') {
                        this.search_user_groups.push(newvArray[1])
                    } else {
                        this.not_assigned = 1
                    }
                })

                this.fetch()
            },

            selected_distribution_method: function (newv, oldv) {
                if (!this.is_fetching)
                    this.fetch()
            },

            userGroups: function (newValue, oldValue) {
                this.fields[5].values = this.full_agencies
            },

            is_fetching: function (newVal, oldVal) {
                var el = document.querySelector('.filter--overlay')
                if (!_.isNil(el)) {
                    if (newVal) {
                        el.style.display = 'block'
                    } else {
                        el.style.display = 'none'
                    }
                }
            }
        }
    }

</script>
<style scoped>
    .marged-top {
        margin-top: 8px;
    }

    .button-margin-top {
        margin-top: 20px;
    }

    .button-margin-bottom {
        margin-bottom: 20px;
    }

    .leads-filter-bar {
        position: relative;
    }

    .filter--overlay {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.35);
        z-index: 9;
    }

</style>



// WEBPACK FOOTER //
// client/components/CRM/FilterBar.vue